import { amazonFreshConfig as config } from '../data/index.js';
/**
 * `amazonFreshCheckout` is the {@link ICheckoutService} for
 * the AmazonFresh retailer integration
 */
export const amazonFreshCheckout = {
    config,
    /**
     * `checkout` executes the amazonFresh-specific functionality to purchase products
     * @param {IRetailerCartItem[]} items - the {@link IRetailerCartItem} array of products to be purchased
     * @param {IRetailerLocation} location - the currently selected {@link IRetailerLocation}
     */
    checkout: ( /* items: IRetailerCartItem[], location: IRetailerLocation */) => {
        console.log('Use checkoutWithAmazon() instead.');
    }
};
/**
 * `checkoutWithAmazon` handles Amazon Fresh & Whole Foods Market checkout.
 * @param {any[]} items - array of all the recipe ingredients
 * @param {string} brandName - name of brand to checkout (either AmazonFresh or Whole Foods Market)
 */
export const checkoutWithAmazon = (items, brandName) => {
    const almBrandId = brandName === 'AmazonFresh'
        ? 'QW1hem9uIEZyZXNo'
        : 'VUZHIFdob2xlIEZvb2Rz';
    const amazonCheckoutUrl = 'https://www.amazon.com/afx/ingredients/landing?tag=allrecipes201-20';
    const ingredients = JSON.stringify({
        ingredients: convertItemsToAmazonProducts(items)
    });
    const formElements = [
        {
            type: 'hidden',
            id: 'ingredients',
            name: 'ingredients',
            value: ingredients
        },
        {
            type: 'hidden',
            id: 'almBrandId',
            name: 'almBrandId',
            value: almBrandId
        },
        {
            type: 'submit'
        }
    ];
    const form = document.createElement('form');
    form.method = 'POST';
    form.target = '_blank';
    form.action = amazonCheckoutUrl;
    formElements.forEach((el) => {
        const element = document.createElement('input');
        Object.assign(element, el);
        form.appendChild(element);
    });
    document.body.appendChild(form);
    form.querySelector('[type="submit"]').click();
    document.body.removeChild(form);
};
export const convertItemsToAmazonProducts = (items) => {
    return items.map((item) => ({
        name: item.ingredientName,
        quantityList: [
            {
                unit: 'count',
                amount: 1
            }
        ]
    }));
};
